export const embroideryProductTitles = [
    'Always Blanket',
    'Coming Home Blanket',
    'Classic Bib',
    'Organic Lounge Robe',
    'Printed Organic Lounge Robe',
    'Organic Lounge Top',
    'Two-Piece Pajamas',
    'Two-Piece Pajama Set',
    'Two-Piece Shortie Pajamas',
    'One-Piece Pajamas',
    'One-Piece Footed Pajamas',
    'Adult Shortie Two-Piece Pajamas',
    'BASIC Crewneck Sweatshirt',
    'BASIC Hoodie',
    'Organic Hooded Towel',
    'Little Darling Knit Top + Bottom',
    'Sweatshirt Romper',
    'Cuddles the Elephant',
    'Cuddles the Lovey',
    'Sherpa Moto Romper',
    'Sherpa Zip-Up Hoodie',
    'Adult Sherpa Crewneck Sweatshirt',
    'Disney Princess Bomber',
    'Peplum Sweatshirt',
    'Classic Romper',
    'Hello Baby Top',
    'Short Sleeve Jack + Jill Bodysuit',
    'Long Sleeve Jack + Jill Bodysuit',
    'Long Sleeve Lucky Bodysuit',
    'Zipper One-Piece',
    'Muslin Burp Cloth',
    'Sherpa Robe Jacket',
    'Bomber Jacket',
    'Zip Bomber Jacket',
    'Matching Family One-Piece Adult Pajamas',
    'Matching Family Two-Piece Adult Pajamas',
    'Hospital Cuddle Box',
    'Hospital Cuddle Box - Mini',
    'Hospital Cuddle Box™ + Friday Baby Baby Basics Kit',
    'Hospital Cuddle Box - Deluxe',
    'Mini Modern Layette Cuddle Box',
    'Classic Modern Layette Cuddle Box',
    'Motherlode Modern Layette Cuddle Box',
    'Motherlode Modern Layette Cuddle Box - Blue',
    'Motherlode Modern Layette Cuddle Box - Pink',
    'Motherlode Modern Layette Cuddle Box - Grey',
    'Mini First Year Box - Blue',
    'Mini First Year Box - Pink',
    'Mini First Year Box - Grey',
    "Baby's First First Year Box",
    "Baby's First First Year Box - Blue",
    "Baby's First First Year Box - Pink",
    "Baby's First First Year Box - Grey",
    'Organic Lounge Robe + Frida Mom Labor and Delivery + Postpartum Recovery Kit',
    'Organic Lounge Robe + Frida Mom Postpartum Recovery Essentials Kit',
    'Terry Bathrobe',
    'Long Sleeve Lucky Bodysuit',
    'Long Sleeve Jack + Jill Bodysuit',
    'Zipper One-Piece',
]

export const embroideryProductHandle = [
    'always-blanket',
    'coming-home-blanket',
    'classic-bib',
    'organic-lounge-robe',
    'printed-organic-lounge-robe',
    'organic-lounge-top',
    'two-piece-pajamas',
    'two-piece-pajama-set',
    'two-piece-shortie-pajamas',
    'one-piece-pajamas',
    'one-piece-footed-pajamas',
    'adult-shortie-two-piece-pajamas',
    'basic-crewneck-sweatshirt',
    'basic-hoodie',
    'organic-hooded-towel',
    'little-darling-knit-top-bottom',
    'sweatshirt-romper',
    'cuddles-the-elephant',
    'cuddles-the-lovey',
    'sherpa-moto-romper',
    'sherpa-zip-up-hoodie',
    'adult-sherpa-a-crewneck-sweatshirt',
    'disney-princess-bomber-d-jacket',
    'peplum-sweatshirt',
    'classic-romper',
    'hello-baby-top',
    'short-sleeve-jack-jill-bodysuit',
    'long-sleeve-jack-jill-bodysuit',
    'long-sleeve-lucky-bodysuit',
    'zipper-one-piece',
    'zipper-one-piece',
    'sherpa-robe-jacket',
    'bomber-jacket',
    'zip-bomber-jacket',
    'matching-family-one-piece-adult-pajamas',
    'matching-family-adult-pajamas',
    'hospital-cuddle-box',
    'hospital-m-cuddle-box-mini',
    'hospital-cuddle-box™-frida-baby-baby-basics-kit',
    'hospital-d-cuddle-box-deluxe',
    'mini-modern-layette-cuddle-box',
    'mini-modern-layette-cuddle-box-blue',
    'mini-modern-layette-cuddle-box-blue-1',
    'mini-modern-layette-cuddle-box-pink',
    'mini-modern-layette-cuddle-box-pink-1',
    'mini-modern-layette-cuddle-box-grey',
    'mini-modern-layette-cuddle-box-grey-1',
    'classic-modern-layette-cuddle-box',
    'motherlode-modern-layette-cuddle-box',
    'motherlode-modern-layette-cuddle-box-blue',
    'motherlode-modern-layette-cuddle-box-pink',
    'motherlode-modern-layette-cuddle-box-grey',
    'mini-first-year-box-blue',
    'mini-first-year-box-pink',
    'mini-first-year-box-grey',
    'babys-first-year-box',
    'babys-first-year-box-blue',
    'babys-first-year-box-pink',
    'babys-first-year-box-grey',
    'organic-lounge-robe-frida-mom-labor-and-delivery-postpartum-recovery-kit',
    'organic-lounge-robe-frida-mom-postpartum-recovery-essentials-kit',
    'terry-bathrobe',
    'long-sleeve-lucky-bodysuit',
    'long-sleeve-jack-jill-bodysuit',
    'zipper-one-piece',
]

export const embroideryData = {
    embroidery: {
        products: [
            {
                product: 'Always Blanket',
                productHandle: 'always-blanket',
                characterLimit: 20,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Coming Home Blanket',
                productHandle: 'coming-home-blanket',
                characterLimit: 20,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Classic Bib',
                productHandle: 'classic-bib',
                characterLimit: 7,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Organic Lounge Robe',
                productHandle: 'organic-lounge-robe',
                characterLimit: 3,
                embroideryTypes: ['Monogram', 'Mama'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: false,
                    },
                    {
                        webName: 'Mama',
                        fontName: 'Boucherie',
                        displayName: 'Mama',
                        active: true,
                    },
                ],
            },
            {
                product: 'Printed Organic Lounge Robe',
                productHandle: 'printed-organic-lounge-robe',
                characterLimit: 3,
                embroideryTypes: ['Monogram', 'Mama'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: false,
                    },
                    {
                        webName: 'Mama',
                        fontName: 'Boucherie',
                        displayName: 'Mama',
                        active: true,
                    },
                ],
            },
            {
                product: 'Organic Lounge Top',
                productHandle: 'organic-lounge-top',
                characterLimit: 3,
                embroideryTypes: ['Monogram'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: false,
                    },
                ],
            },
            {
                product: 'Two-Piece Pajamas',
                productHandle: 'two-piece-pajamas',
                characterLimit: 1,
                isSingleLetter: true,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Two-Piece Pajama Set',
                productHandle: 'two-piece-pajama-set',
                characterLimit: 10,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Short SleeveTwo-Piece Pajama Set',
                productHandle: 'short-sleeve-two-piece-s-pajama-set',
                characterLimit: 10,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Two-Piece Shorty Pajamas',
                productHandle: 'two-piece-shorty-pajamas',
                characterLimit: 1,
                isSingleLetter: true,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Two-Piece Shorty Pajama Set',
                productHandle: 'two-piece-shorty-pajama-set',
                characterLimit: 1,
                isSingleLetter: true,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Matching Family Two-Piece Pajama Set',
                productHandle: 'matching-family-two-m-piece-pajama-set',
                characterLimit: 10,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'One-Piece Baby Pajamas',
                productHandle: 'one-piece-baby-pajamas',
                characterLimit: 10,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'One-Piece Baby Footed Pajamas',
                productHandle: 'one-piece-baby-footed-pajamas',
                characterLimit: 10,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Adult Shortie Two-Piece Pajamas',
                productHandle: 'adult-shortie-two-piece-pajamas',
                characterLimit: 1,
                isSingleLetter: true,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Zip-Up Hoodie',
                productHandle: 'zip-up-hoodie',
                characterLimit: 10,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'BASIC Crewneck Sweatshirt',
                productHandle: 'basic-crewneck-sweatshirt',
                characterLimit: 10,
                twoLines: true,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'BASIC Hoodie',
                productHandle: 'basic-hoodie',
                characterLimit: 10,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },

            {
                product: 'Two-Piece Shortie Pajama Set',
                productHandle: 'two-piece-shortie-pajama-set',
                characterLimit: 10,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Organic Hooded Towel',
                productHandle: 'organic-hooded-towel',
                characterLimit: 7,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Little Darling Knit Top + Bottom',
                productHandle: 'little-darling-knit-top-bottom',
                characterLimit: 1,
                isSingleLetter: true,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Sweatshirt Romper',
                productHandle: 'sweatshirt-r-romper',
                characterLimit: 12,
                isSingleLetter: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Cuddles the Elephant',
                productHandle: 'cuddles-the-elephant',
                characterLimit: 1,
                isSingleLetter: true,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Cuddles the Lovey',
                productHandle: 'cuddles-the-lovey',
                characterLimit: 7,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Sherpa Moto Romper',
                productHandle: 'sherpa-moto-romper',
                characterLimit: 1,
                isSingleLetter: true,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Sherpa Top + Bottom Set',
                productHandle: 'sherpa-top-bottom-set',
                characterLimit: 1,
                isSingleLetter: true,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Sherpa Zip-Up Hoodie',
                productHandle: 'sherpa-zip-up-hoodie',
                characterLimit: 1,
                isSingleLetter: true,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Adult Sherpa Crewneck Sweatshirt',
                productHandle: 'adult-sherpa-a-crewneck-sweatshirt',
                characterLimit: 1,
                isSingleLetter: true,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Sherpa Crewneck Sweatshirt',
                productHandle: 'sherpa-crewneck-sweatshirt',
                characterLimit: 1,
                isSingleLetter: true,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Moto Romper',
                productHandle: 'moto-romper',
                characterLimit: 1,
                isSingleLetter: true,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Disney Princess Bomber',
                productHandle: 'disney-princess-bomber-d-jacket',
                characterLimit: 6,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Peplum Sweatshirt',
                productHandle: 'peplum-sweatshirt',
                characterLimit: 1,
                isSingleLetter: true,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Classic Romper',
                productHandle: 'classic-romper',
                characterLimit: 1,
                isSingleLetter: true,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Hello Baby Top',
                productHandle: 'hello-baby-top',
                characterLimit: 16,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Short Sleeve Jack + Jill Bodysuit',
                productHandle: 'short-sleeve-jack-jill-bodysuit',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Long Sleeve Jack + Jill Bodysuit',
                productHandle: 'long-sleeve-jack-jill-bodysuit',
                characterLimit: 12,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Long Sleeve Lucky Bodysuit',
                productHandle: 'long-sleeve-lucky-bodysuit',
                characterLimit: 16,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Zipper One-Piece',
                productHandle: 'zipper-one-piece',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Muslin Burp Cloth',
                productHandle: 'muslin-burp-cloth',
                characterLimit: 10,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Organic Burp Cloth',
                productHandle: 'organic-burp-cloth',
                characterLimit: 10,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Embroidered Zip-Up Hoodie',
                productHandle: 'embroidered-zip-up-hoodie',
                characterLimit: 10,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Double Ruffle Romper',
                productHandle: 'double-ruffle-romper',
                characterLimit: 12,
                twoLines: false,
                embroideryTypes: ['Single Letter', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Short Sleeve Lucky Bodysuit',
                productHandle: 'short-sleeve-lucky-bodysuit',
                characterLimit: 12,
                twoLines: false,
                embroideryTypes: ['Monagram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Kimono Tie One-Piece',
                productHandle: 'kimono-tie-one-piece',
                characterLimit: 12,
                twoLines: false,
                embroideryTypes: ['Monagram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Baby Cardigan',
                productHandle: 'baby-b-cardigan',
                characterLimit: 3,
                twoLines: false,
                embroideryTypes: ['Monagram', 'Single Letter'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Little Belle Tulle Dress',
                productHandle: 'little-belle-tulle-dress',
                characterLimit: 10,
                twoLines: false,
                embroideryTypes: ['Monagram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Baby 3-Piece Knit Set',
                productHandle: 'baby-3-piece-knit-set',
                characterLimit: 3,
                twoLines: false,
                embroideryTypes: ['Monagram', 'Single Letter'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Baby Sweater Dress',
                productHandle: 'baby-sweater-dress',
                characterLimit: 12,
                twoLines: false,
                embroideryTypes: ['Monagram', 'Single Letter', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Ribbed Cotton Zipper One-Piece',
                productHandle: 'ribbed-cotton-zipper-r-one-piece',
                characterLimit: 12,
                twoLines: false,
                embroideryTypes: ['Monagram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Pointelle Zipper One-Piece',
                productHandle: 'pointelle-zipper-p-one-piece',
                characterLimit: 12,
                twoLines: false,
                embroideryTypes: ['Monagram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Sherpa Robe Jacket',
                productHandle: 'sherpa-robe-jacket',
                characterLimit: 10,
                embroideryTypes: ['Monogram', 'Mama'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: false,
                    },
                    {
                        webName: 'Mama',
                        fontName: 'Boucherie',
                        displayName: 'Mama',
                        active: false,
                    },
                ],
            },
            {
                product: 'Bomber Jacket',
                productHandle: 'bomber-jacket',
                characterLimit: 1,
                isSingleLetter: true,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: false,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: false,
                    },
                ],
            },
            {
                product: 'Sherpa Bomber Jacket',
                productHandle: 'sherpa-bomber-s-jacket',
                characterLimit: 1,
                isSingleLetter: true,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: false,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: false,
                    },
                ],
            },
            {
                product: 'Zip Bomber Jacket',
                productHandle: 'zip-bomber-z-jacket',
                characterLimit: 1,
                isSingleLetter: true,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: false,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: false,
                    },
                ],
            },
            {
                product: 'Matching Family One-Piece Adult Pajamas',
                productHandle: 'matching-family-one-piece-adult-pajamas',
                characterLimit: 1,
                isSingleLetter: true,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Matching Family Two-Piece Adult Pajamas',
                productHandle: 'matching-family-adult-pajamas',
                characterLimit: 1,
                isSingleLetter: true,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Hospital Cuddle Box',
                productHandle: 'hospital-cuddle-box',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Hospital Cuddle Box - Mini',
                productHandle: 'hospital-m-cuddle-box-mini',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Hospital Cuddle Box™ + Friday Baby Baby Basics Kit',
                productHandle:
                    'hospital-cuddle-box™-frida-baby-baby-basics-kit',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Hospital Cuddle Box - Deluxe',
                productHandle: 'hospital-d-cuddle-box-deluxe',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Mini Modern Layette Cuddle Box',
                productHandle: 'mini-modern-layette-cuddle-box',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Mini Modern Layette Cuddle Box - Blue',
                productHandle: 'mini-modern-layette-cuddle-box-blue',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Mini Modern Layette Cuddle Box - Blue',
                productHandle: 'mini-modern-layette-cuddle-box-blue-1',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Mini Modern Layette Cuddle Box - Pink',
                productHandle: 'mini-modern-layette-cuddle-box-pink',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Mini Modern Layette Cuddle Box - Pink',
                productHandle: 'mini-modern-layette-cuddle-box-pink-1',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Mini Modern Layette Cuddle Box - Grey',
                productHandle: 'mini-modern-layette-cuddle-box-grey',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Mini Modern Layette Cuddle Box - Grey',
                productHandle: 'mini-modern-layette-cuddle-box-grey-1',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Classic Modern Layette Cuddle Box',
                productHandle: 'classic-modern-layette-cuddle-box',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Classic Modern Layette Cuddle Box - Blue',
                productHandle: 'classic-modern-layette-cuddle-box-blue',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Classic Modern Layette Cuddle Box - Blue',
                productHandle: 'classic-modern-layette-cuddle-box-blue-1',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Classic Modern Layette Cuddle Box - Pink',
                productHandle: 'classic-modern-layette-cuddle-box-pink',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Classic Modern Layette Cuddle Box - Pink',
                productHandle: 'classic-modern-layette-cuddle-box-pink-1',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Classic Modern Layette Cuddle Box - Grey',
                productHandle: 'classic-modern-layette-cuddle-box-grey',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Classic Modern Layette Cuddle Box - Grey',
                productHandle: 'classic-modern-layette-cuddle-box-grey-1',
                characterLimit: 20,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Motherlode Modern Layette Cuddle Box',
                productHandle: 'motherlode-modern-layette-cuddle-box',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Motherlode Modern Layette Cuddle Box - Blue',
                productHandle: 'motherlode-modern-layette-cuddle-box-blue',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Motherlode Modern Layette Cuddle Box - Blue',
                productHandle: 'motherlode-modern-layette-cuddle-box-blue-1',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Motherlode Modern Layette Cuddle Box - Pink',
                productHandle: 'motherlode-modern-layette-cuddle-box-pink',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Motherlode Modern Layette Cuddle Box - Pink',
                productHandle: 'motherlode-modern-layette-cuddle-box-pink-1',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Motherlode Modern Layette Cuddle Box - Grey',
                productHandle: 'motherlode-modern-layette-cuddle-box-grey',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Motherlode Modern Layette Cuddle Box - Grey',
                productHandle: 'motherlode-modern-layette-cuddle-box-grey-1',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Mini First Year Box - Blue',
                productHandle: 'mini-first-year-box-blue',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Mini First Year Box - Pink',
                productHandle: 'mini-first-year-box-pink',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Mini First Year Box - Grey',
                productHandle: 'mini-first-year-box-grey',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: "Baby's First First Year Box",
                productHandle: 'babys-first-year-box',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: "Baby's First First Year Box - Blue",
                productHandle: 'babys-first-year-box-blue',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: "Baby's First First Year Box - Pink",
                productHandle: 'babys-first-year-box-pink',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: "Baby's First First Year Box - Grey",
                productHandle: 'babys-first-year-box-grey',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product:
                    'Organic Lounge Robe + Frida Mom Labor and Delivery + Postpartum Recovery Kit',
                productHandle:
                    'organic-lounge-robe-frida-mom-labor-and-delivery-postpartum-recovery-kit',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Mama'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: false,
                    },
                    {
                        webName: 'Mama',
                        fontName: 'Boucherie',
                        displayName: 'Mama',
                        active: false,
                    },
                ],
            },
            {
                product:
                    'Organic Lounge Robe + Frida Mom Postpartum Recovery Essentials Kit',
                productHandle:
                    'organic-lounge-robe-frida-mom-postpartum-recovery-essentials-kit',
                characterLimit: 20,
                embroideryTypes: ['Monogram', 'Mama'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: false,
                    },
                    {
                        webName: 'Mama',
                        fontName: 'Boucherie',
                        displayName: 'Mama',
                        active: false,
                    },
                ],
            },
            {
                product: 'Terry Bathrobe',
                productHandle: 'terry-bathrobe',
                characterLimit: 3,
                embroideryTypes: ['Monogram', 'Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: false,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: false,
                    },
                    {
                        webName: 'Mama',
                        fontName: 'Boucherie',
                        displayName: 'Mama',
                        active: false,
                    },
                ],
            },
            {
                product: 'Zipper One-Piece',
                productHandle: 'zipper-one-piece',
                characterLimit: 10,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Hello Baby Top',
                productHandle: 'hello-baby-top',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Hello Baby Set',
                productHandle: 'hello-baby-set',
                characterLimit: 10,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Short Sleeve Jack + Jill Bodysuit',
                productHandle: 'short-sleeve-jack-jill-bodysuit',
                characterLimit: 10,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Long Sleeve Jack + Jill Bodysuit',
                productHandle: 'long-sleeve-jack-jill-bodysuit',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Long Sleeve Lucky Bodysuit',
                productHandle: 'long-sleeve-lucky-bodysuit',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Terry Bathrobe',
                productHandle: 'terry-bathrobe',
                characterLimit: 3,
                embroideryTypes: ['Text', 'Monogram', 'Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: false,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: false,
                    },
                ],
            },
            {
                product: 'Tote + Treat Bag',
                productHandle: 'tote-treat-bag',
                characterLimit: 25,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Collegiate Cardigan',
                productHandle: 'collegiate-cardigan',
                characterLimit: 7,
                embroideryTypes: ['Single', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Waffle Sporty Sweatshirt',
                productHandle: 'waffle-sporty-w-sweatshirt',
                characterLimit: 10,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Waffle Kimono Tie One-Piece',
                productHandle: 'waffle-kimono-w-tie-one-piece',
                characterLimit: 10,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Waffle Kimono Tie One-Piece',
                productHandle: 'waffle-kimono-w-tie-one-piece',
                characterLimit: 10,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Kimono Sweater Romper',
                productHandle: 'kimono-sweater-romper',
                characterLimit: 10,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Lucky Baby Cardigan',
                productHandle: 'lucky-baby-cardigan',
                characterLimit: 1,
                embroideryTypes: ['Monogram', 'Text', 'Single Letter'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Lucky Baby Cardigan',
                productHandle: 'lucky-l-baby-cardigan',
                characterLimit: 1,
                embroideryTypes: ['Monogram', 'Text', 'Single Letter'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Knit Oxford Shirt',
                productHandle: 'knit-oxford-shirt',
                characterLimit: 12,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Knit Overalls',
                productHandle: 'knit-overalls',
                characterLimit: 12,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Knit Zipper Romper',
                productHandle: 'knit-zipper-romper',
                characterLimit: 1,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text', 'Single Letter'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Short Sleeve Oxford Shirt',
                productHandle: 'short-sleeve-oxford-shirt',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Short Sleeve Crewneck Tee',
                productHandle: 'short-sleeve-crewneck-tee',
                characterLimit: 10,
                embroideryTypes: ['Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Ribbed Bubble Bodysuit',
                productHandle: 'ribbed-bubble-r-bodysuit',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Ribbed Bodysuit',
                productHandle: 'ribbed-bodysuit',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Bubble Bodysuit',
                productHandle: 'bubble-bodysuit',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Oxford Shirt Brooklyn Sweatpant Bundle',
                productHandle: 'oxford-shirt-brooklyn-sweatpant-bundle',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },

            {
                product: 'Ribbed Spaghetti Strap Dress',
                productHandle: 'ribbed-spaghetti-rstrap-dress',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },

            {
                product: 'Ribbed Spaghetti Strap Dress',
                productHandle: 'ribbed-spaghetti-r-strap-dress',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Ribbed Top + Shorts Set',
                productHandle: 'ribbed-top-shorts-set',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Ribbed Button Up Romper',
                productHandle: 'ribbed-button-up-romper',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Ribbed Velour Turtleneck',
                productHandle: 'ribbed-velour-turtleneck',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Corduroy Overalls',
                productHandle: 'corduroy-overalls',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Corduroy Pinafore Dress',
                productHandle: 'corduroy-pinafore-dress',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Knot It Gown',
                productHandle: 'knot-it-gown',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Pocket Sweatshirt Shortall',
                productHandle: 'pocket-sweatshirt-shortall',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Sweet Baby B Romper',
                productHandle: 'sweet-baby-b-romper',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'On The Go One-Piece',
                productHandle: 'on-the-go-one-piece',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Organic Arms Out Sleep Bag',
                productHandle: 'organic-arms-out-sleep-bag',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Top Knot Cap',
                productHandle: 'top-knot-cap',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Long Sleeve Crewneck Tee',
                productHandle: 'long-sleeve-crewneck-tee',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Organic Short Sleeve Polo',
                productHandle: 'organic-short-sleeve-polo',
                characterLimit: 10,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Organic Crib Quilt',
                productHandle: 'organic-crib-quilt',
                characterLimit: 20,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Snuggle Up Blanket',
                productHandle: 'snuggle-up-blanket',
                characterLimit: 20,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Family Knit Throw Blanket',
                productHandle: 'family-knit-throw-blanket',
                characterLimit: 20,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Tulle Sleeve Shirt',
                productHandle: 'tulle-sleeve-shirt',
                characterLimit: 10,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: "Velour Long Sleeve Ruffle Let's Dance Dress",
                productHandle: 'velour-long-sleeve-ruffle-lets-dance-dress',
                characterLimit: 10,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Sherpa Teddy Cardigan',
                productHandle: 'sherpa-teddy-cardigan',
                characterLimit: 1,
                embroideryTypes: ['Single Letter'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: false,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: false,
                    },
                ],
            },
            {
                product: 'Garden Party Dress',
                productHandle: 'garden-party-dress',
                characterLimit: 10,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Old Sport Jacket',
                productHandle: 'old-sport-jacket',
                characterLimit: 3,
                embroideryTypes: ['Monogram', 'Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: false,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: false,
                    },
                ],
            },
            {
                product: 'Old Sport Suit',
                productHandle: 'old-sport-suit',
                characterLimit: 3,
                embroideryTypes: ['Monogram', 'Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: false,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: false,
                    },
                ],
            },
            {
                product: 'Oxford Romper',
                productHandle: 'oxford-romper',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Short Sleeve Henley Tee',
                productHandle: 'short-sleeve-henley-tee',
                characterLimit: 10,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Denim Jacket',
                productHandle: 'denim-jacket',
                characterLimit: 12,
                twoLines: false,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: false,
                    },
                ],
            },
            {
                product: 'Knit Polo Romper',
                productHandle: 'knit-polo-romper',
                characterLimit: 3,
                embroideryTypes: ['Monogram', 'Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Knit Polo Romper',
                productHandle: 'knit-polo-p-romper',
                characterLimit: 3,
                embroideryTypes: ['Monogram', 'Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Big Collar Sweater',
                productHandle: 'big-collar-sweater',
                characterLimit: 3,
                embroideryTypes: ['Monogram', 'Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Polo Sweater',
                productHandle: 'polo-sweater',
                characterLimit: 3,
                embroideryTypes: ['Monogram', 'Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Sweater Pocket Dress',
                productHandle: 'sweater-pocket-dress',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Single', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Sweater Turtleneck',
                productHandle: 'sweater-turtleneck',
                characterLimit: 12,
                embroideryTypes: ['Monogram', 'Single', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Lightweight Sweater Romper',
                productHandle: 'lightweight-sweater-l-romper',
                characterLimit: 12,
                embroideryTypes: ['Single', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Sweater Romper',
                productHandle: 'sweater-r-romper',
                characterLimit: 12,
                embroideryTypes: ['Single', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Sweater Romper',
                productHandle: 'sweater-romper',
                characterLimit: 12,
                embroideryTypes: ['Single', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Ruffle Collar Cardigan',
                productHandle: 'ruffle-collar-cardigan',
                characterLimit: 3,
                embroideryTypes: ['Single', 'Monogram'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Velour Moto Romper',
                productHandle: 'velour-moto-v-romper',
                characterLimit: 1,
                isSingleLetter: true,
                embroideryTypes: ['Single'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: false,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: false,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: false,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: false,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: false,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: false,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: false,
                    },
                ],
            },
            {
                product: 'Side Tie Baby Top',
                productHandle: 'side-tie-baby-top',
                characterLimit: 12,
                embroideryTypes: ['Text', 'Monogram'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Short Sleeve Polo + Old Sport Short Set',
                productHandle: 'short-sleeve-polo-old-sport-short-set',
                characterLimit: 10,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Cozy Blanket',
                productHandle: 'cozy-blanket',
                characterLimit: 20,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Cardigan + Pant Set',
                productHandle: 'cardigan-pant-set',
                characterLimit: 3,
                twoLines: false,
                embroideryTypes: ['Monogram', 'Single Letter'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Newborn Blanket',
                productHandle: 'newborn-blanket',
                characterLimit: 20,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Zip-Up Sweater',
                productHandle: 'zip-up-sweater',
                characterLimit: 3,
                twoLines: false,
                embroideryTypes: ['Monogram', 'Single Letter'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'One-Piece Baby Footed Pajamas',
                productHandle: 'one-f-piece-baby-footed-pajamas',
                characterLimit: 10,
                twoLines: true,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Side Tie Sweater Romper',
                productHandle: 'side-tie-sweater-s-romper',
                characterLimit: 12,
                twoLines: false,
                embroideryTypes: ['Single Letter', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Baby Shorty Pajamas',
                productHandle: 'baby-shorty-pajamas',
                characterLimit: 10,
                twoLines: false,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Short Sleeve Tulle Dress',
                productHandle: 'short-sleeve-tulle-dress',
                characterLimit: 10,
                twoLines: false,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Ribbed Short Sleeve Crewneck Tee',
                productHandle: 'ribbed-short-sleeve-r-crewneck-tee',
                characterLimit: 12,
                twoLines: false,
                embroideryTypes: ['Monogram', 'Text'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: true,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: true,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
            {
                product: 'Adult Two-Piece Pajamas',
                productHandle: 'adult-two-piece-a-pajamas',
                characterLimit: 1,
                twoLines: false,
                embroideryTypes: ['Single Letter'],
                fonts: [
                    {
                        webName: 'Handwriting',
                        fontName: 'Bellas Hand',
                        displayName: 'Handwriting',
                        active: true,
                    },
                    {
                        webName: 'Cursive',
                        fontName: 'Castledown Cursive',
                        displayName: 'Cursive',
                        active: true,
                    },
                    {
                        webName: 'Calligraphy',
                        fontName: 'Boucherie',
                        displayName: 'Calligraphy',
                        active: true,
                    },
                    {
                        webName: 'Typewriter',
                        fontName: 'Garton',
                        displayName: 'Typewriter',
                        active: true,
                    },
                    {
                        webName: 'Sans Serif',
                        fontName: 'Styrene',
                        displayName: 'Sans Serif',
                        active: true,
                    },
                    {
                        webName: 'Serif',
                        fontName: 'Value Serif',
                        displayName: 'Serif',
                        active: true,
                    },
                    {
                        webName: 'Monogram',
                        fontName: 'Round Monogram',
                        displayName: 'Monogram',
                        active: false,
                    },
                    {
                        webName: 'Athletic',
                        fontName: 'Hoboken High',
                        displayName: 'Athletic',
                        active: false,
                    },
                    {
                        webName: 'Learning Curve',
                        fontName: 'Learning Curve',
                        displayName: 'Script',
                        active: true,
                    },
                ],
            },
        ],
        fonts: [
            {
                fontId: 1,
                webName: 'Handwriting',
                fontName: 'Bellas Hand',
                displayName: 'Handwriting',
                fontImage: '/assets/images/bellas-hand_handwriting.png',
            },
            {
                fontId: 2,
                webName: 'Cursive',
                fontName: 'Castledown Cursive',
                displayName: 'Cursive',
                fontImage: '/assets/images/castledown-cursive_cursive.png',
            },
            {
                fontId: 3,
                webName: 'Calligraphy',
                fontName: 'Boucherie',
                displayName: 'Calligraphy',
                fontImage: '/assets/images/boucherie_calligraphy.png',
            },
            {
                fontId: 4,
                webName: 'Typewriter',
                fontName: 'Garton',
                displayName: 'Typewriter',
                fontImage: '/assets/images/garton_typewriter.png',
            },
            {
                fontId: 5,
                webName: 'Sans Serif',
                fontName: 'Styrene',
                displayName: 'Sans Serif',
                fontImage: '/assets/images/styrene-b_sans-serif.png',
            },
            {
                fontId: 6,
                webName: 'Serif',
                fontName: 'Value Serif',
                displayName: 'Serif',
                fontImage: '/assets/images/value-serif_serif.png',
            },
            {
                fontId: 7,
                webName: 'Monogram',
                fontName: 'Round Monogram',
                displayName: 'Monogram',
                fontImage: '/assets/images/round-monogram_monogram.png',
            },
            {
                fontId: 8,
                webName: 'Athletic',
                fontName: 'Hoboken High',
                displayName: 'Athletic',
                fontImage: '/assets/images/hoboken-serif_athletic.png',
            },
            {
                fontId: 9,
                webName: 'Learning Curve',
                fontName: 'Learning Curve',
                displayName: 'Script',
                fontImage: '/assets/images/school-house_script.png',
            },
            {
                fontId: 10,
                webName: 'Mama',
                fontName: 'Boucherie',
                displayName: 'Mama',
                fontImage: '/assets/images/mama_mama.png',
            },

        ],
        threads: [
            {
                threadColor: '5921 - Magnolia',
                name: 'Pink',
                hex: '#F6B7D2',
            },
            {
                threadColor: '5838 - Lipstick',
                name: 'Red',
                hex: '#B7403D',
            },
            {
                threadColor: '5465 - Papaya',
                name: 'Orange',
                hex: '#EA7542',
            },

            {
                threadColor: '5670 - Gold',
                name: 'Gold',
                hex: '#C19846',
            },

            {
                threadColor: '5802 - Snow White',
                name: 'White',
                hex: '#FFFFFF',
            },
            {
                threadColor: '5500 - Diamond Black',
                name: 'Black',
                hex: '#414042',
            },
            {
                threadColor: '5488 - Garden Green',
                name: 'Green',
                hex: '#67C18C',
            },
            {
                threadColor: '5542 - Baby Blue',
                name: 'Blue',
                hex: '#94BDE5',
            },
            {
                threadColor: '5964 - Ash Blue',
                name: 'Ash Blue',
                hex: '#455287',
            },
            {
                threadColor: '5834 - Lilac',
                name: 'Purple',
                hex: '#A7A0CB',
            },
            {
                threadColor: '5811 - Silver',
                name: 'Grey',
                hex: '#E6E7E8',
            },
            {
                threadColor: '5597 - Neon Pink',
                name: 'Neon Pink',
                hex: '#FCA4DC',
            },
        ],
    },
}
